import React, { FC } from 'react';
import { KeycloakAutoLogout } from './AutoLogoutKeycloak';
import { OidcAutoLogout } from './AutoLogoutOidc';

export type AutoLogoutProps = {
    idleTimeInMinutes: number;
    redirectUri: string;
    oidc?: boolean;
    debounce?: number;
    children?: React.ReactNode;
};

export const AutoLogout: FC<AutoLogoutProps> = ({
    redirectUri,
    idleTimeInMinutes,
    debounce = 1000,
    oidc,
    children,
}) => {
    if (oidc) {
        return (
            <OidcAutoLogout redirectUri={redirectUri} idleTimeInMinutes={idleTimeInMinutes} debounce={debounce}>
                {children}
            </OidcAutoLogout>
        );
    } else {
        return (
            <KeycloakAutoLogout redirectUri={redirectUri} idleTimeInMinutes={idleTimeInMinutes} debounce={debounce}>
                {children}
            </KeycloakAutoLogout>
        );
    }
};
